import { render, staticRenderFns } from "./secondary-tabs.vue?vue&type=template&id=75bc7b80&"
import script from "./secondary-tabs.vue?vue&type=script&lang=js&"
export * from "./secondary-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports